import React, { useEffect, useState } from 'react';
import Background from '../../components/Background/Background';
import Button from '../../components/Button/Button';
import Header from '../../components/Header/Header';
import './_styles.welcome.css';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import fadeIn from '../../animations/fadeIn';
import {
  anonymousLogin,
  logout,
  resetStatus
} from '../../store/slices/authSlice';
import { useAppDispatch, useAppSelector } from '../../hooks/useApp';
import { resetState } from '../../store/slices/awardsSlice';

const Welcome = () => {
  const navigate = useNavigate();
  const [submitAnon, setSubmitAnon] = useState(false);

  const { status, token } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();

  const onSignInClick = () => {
    dispatch(logout());
    dispatch(resetState());
    navigate('/signin');
  };

  useEffect(() => {
    if (status === 'success' && submitAnon) {
      setSubmitAnon(false);
      dispatch(resetStatus());
      navigate('/points');
    }

    return () => {};
  }, [dispatch, navigate, status, submitAnon]);

  const onContinueClick = () => {
    setSubmitAnon(true);
    if (!token) {
      dispatch(anonymousLogin());
    } else {
      navigate('/points');
    }
  };

  return (
    <Background image='welcome'>
      <Header title='Welcome' showHome={false} />
      <div className='text-container'>
        <motion.p
          className='w-full md:w-[70%] mx-auto'
          variants={fadeIn()}
          initial='hidden'
          animate='enter'
          exit='exit'
        >
          Want to know if you have enough points or miles to book a flight or
          hotel?
        </motion.p>
        <motion.p
          className='w-full md:w-[70%] mx-auto'
          variants={fadeIn(0.15)}
          initial='hidden'
          animate='enter'
          exit='exit'
        >
          This basic version of Awayz does just that. And with Odynn's unique
          algorithm behind it, it's simple and easy to use.
        </motion.p>
        <motion.p
          className='w-full md:w-[70%] mx-auto'
          variants={fadeIn(0.15)}
          initial='hidden'
          animate='enter'
          exit='exit'
        >
          We've made it easy to use, whether you're exploring the world or
          simply taking a weekend away.
        </motion.p>
      </div>
      <div className='flex flex-col w-full gap-4'>
        <motion.p
          className='w-full md:w-[60%] mx-auto text-xs text-center text-white'
          variants={fadeIn(0.3)}
          initial='hidden'
          animate='enter'
          exit='exit'
        >
          Flight and hotel results are calculated two months from the date of
          your search.
        </motion.p>
        <Button loading={status === 'loading'} onClick={onContinueClick}>
          Try it out
        </Button>
        <Button onClick={onSignInClick} type='secondary' delay={0.2}>
          Sign In
        </Button>
      </div>
    </Background>
  );
};

export default Welcome;
